import { pagingOptions } from "../helpers/index";
export default {
  data() {
    return {
      pagingOptions,
      search: "",
    };
  },
  computed: {
    gridHeight() {
      return this.items && this.items.length >= 20 ? 800 : null;
    },
    filteredHeaders() {
      return [
        ...this.headers.filter(
          (h) => this.visibleColumns.indexOf(h.name) > -1 || h.name == "actions"
        ),
      ];
    },
    selectableHeaders() {
      return this.headers.filter((h) => h.name != "actions");
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    onVisibleColumnsChange(event) {
      this.visibleColumns = [...event];
      this.$store.dispatch("updateLocalSettings", {
        [this.$options.name]: event,
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/SimpleListMixin.js